import { Tabs } from "@asayinc/component-library";
import { Box } from "@mui/material";
import { Outlet, useMatch, useNavigate, useParams } from "react-router-dom";

import { BackLink } from "src/components/atoms/BackLink";
import { ErrorState } from "src/components/atoms/ErrorState";
import { PageContainer } from "src/components/containers/PageContainer/PageContainer";
import { EventPageHeader } from "src/components/molecules/EventPageHeader";
import { LoadingHeader } from "src/components/molecules/Loading/LoadingHeader";
import { LOCATION_ANALYSIS_EVENT_LABEL } from "src/constants/labels/locationAnalysisEventLabel";
import { LOCATION_ANALYSIS_EVENT_TABS } from "src/constants/tabs";
import { useLocationAnalysisEventQuery } from "src/store/locationAnalysisEvent";

export function LocationAnalysisEvent() {
  const navigate = useNavigate();
  const { id } = useParams() as { id: string };
  const {
    data: locationAnalysisEvent,
    isLoading,
    error,
  } = useLocationAnalysisEventQuery({ id });
  const match = useMatch(`/location-analysis-events/${id}/:activeTab`) as {
    params: { activeTab: string };
  };

  const handleTabChange = (value: string) => {
    navigate(`/location-analysis-events/${id}/${value}`);
  };

  if (error || (!isLoading && !locationAnalysisEvent)) {
    return <ErrorState />;
  }

  return (
    <PageContainer>
      <BackLink
        sx={{ mb: 3, ml: -2, pt: 10, px: 10 }}
        label="Location Analysis Events"
        to={`/reports/location-analysis-events?view=${
          locationAnalysisEvent?.operationsStatus === "approved"
            ? "approved"
            : "upcoming"
        }`}
      />
      {isLoading ? (
        <LoadingHeader sx={{ px: 10 }} numberOfRows={1} />
      ) : (
        <EventPageHeader
          backLink={`/location-analysis-events/${id}/details`}
          issuerName={locationAnalysisEvent.issuer.name || "-"}
          issuerId={locationAnalysisEvent.issuer?.id}
          type={LOCATION_ANALYSIS_EVENT_LABEL[locationAnalysisEvent.type]}
          subHeader={
            locationAnalysisEvent.jobNumber
              ? `${locationAnalysisEvent.solicitor.name} - ${locationAnalysisEvent.jobNumber}`
              : locationAnalysisEvent.solicitor.name
          }
          sx={{ px: 10 }}
        />
      )}
      <Box sx={{ mx: 10, mt: 3 }}>
        <Tabs
          activeTab={match?.params?.activeTab || "details"}
          clickHandler={handleTabChange}
          tabs={LOCATION_ANALYSIS_EVENT_TABS}
        />
      </Box>
      <Outlet />
    </PageContainer>
  );
}
